import React from "react";
import { ImageLine } from "@ui/IconV2/react";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";
import type { BlockImageModelT } from "../../../../../../schema/block/image";

export const ImageTemplate = {
  icon: () => <ImageLine size="l" color={colors.carbon800} />,
  title: t("project.dashboard.block.template.image.sub_subtitle"),
  description: null,
  block: {
    kind: "IMAGE",
    data: "",
    config: {
      url: "",
    },
  } as Omit<BlockImageModelT, "dashboardId" | "position">,
};
